import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { Http, Response } from '@angular/http';
import { REDEEM_INVESTOR } from '../../models/Redeem';
import { ISSUANCE_INVESTOR } from '../../models/issuance';
import { VW_SERIES_SA } from '../../models/seriessa';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../../header.service';
import { ProfileService } from '../../profile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { PaginationComponent } from "../../pagination/pagination.component";
import * as Globals from '../../globals';
import { ExcelService } from 'app/excel.service';
const url = Globals.serviceUrl;
declare var $: any;


@Component({
  selector: 'app-custom-pemesanan',
  templateUrl: './custom-pemesanan.component.html',
  styleUrls: ['./custom-pemesanan.component.css']
})
export class CustomPemesananComponent implements OnInit {
  @ViewChild(PaginationComponent) child: PaginationComponent;
  authMenu: any;
  tab: number = 1;
  userProfile: any;
  loading: boolean;
  series: any[];
  rawdata: any[];
  seriesId: number;
  paramSeries: any = { OPEN: false };
  issuances: any[];
  totBids: number = 0;
  totAlts: number = 0;
  cds: any = [];
  seriessa: VW_SERIES_SA[];
  search: string = '';
  status: string = '';
  pageSize: number = 10;
  sort: string[] = ['-BIDDATE'];
  reverse: boolean = true;
  col: number = -5;
  statusId: number = 0;
  ssId: number = 0;
  all: boolean;
  pagedList: any;
  pageNumber: number = 1;
  param: any;
  sid: string;
  asOf: string;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router, private excelService: ExcelService) {
    this.issuances = [];
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/ritelonline/monitoring/pemesanan/0') {
          this.tab = 1;
          this.router.navigate(['/ritelonline/monitoring/pemesanan/1']);
        }
      };
    });
  }
  ngOnInit() {

    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getSeries();
      this.authMenu = Globals.getAuthMenu(205, this.userProfile);
    }
  }

  colSort(val: number) {
    if (this.col == val) {
      val = -val;
    }
    this.col = val;
    this.reverse = !this.reverse;
    switch (val) {
      case 1:
        this.sort = ['INV_ID'];
        break;
      case 2:
        this.sort = ['INVNAME'];
        break;
      case -2:
        this.sort = ['-INVNAME'];
        break;
      case 3:
        this.sort = ['SID'];
        break;
      case -3:
        this.sort = ['-SID'];
        break;
      case 4:
        this.sort = ['ALT_AMT'];
        break;
      case 5:
        this.sort = ['BIDDATE'];
        break;
      case -5:
        this.sort = ['-BIDDATE'];
        break;
      case 6:
        this.sort = ['BIDAMT'];
        break;
      case -6:
        this.sort = ['-BIDAMT'];
        break;
      case 7:
        this.sort = ['CreatedName'];
        break;
      case -7:
        this.sort = ['-CreatedName'];
        break;
      case 8:
        this.sort = ['STAT_ISSUE'];
        break;
      default:
        break;
    }
    this.getIssues(1);
  }

  seriesChanged(ev: any) {
    this.seriesId = ev.target.value;
    this.getIssues(1);
    for (var i = 0; i < this.series.length; i++) {
      if (this.seriesId == this.series[i].SERIES_ID) {
        this.paramSeries = this.series[i];
        break;
      }
    }
  }

  statusChanged(ev: any) {
    if (ev == 0) {
      this.status = null;
    }
    else {
      this.status = ev.target.value;
    }
    this.getIssues(1);
  }

  ssIdChanged(ev: any) {
    this.ssId = ev.target.value;
    this.getIssues(1);
  }

  getSeries() {
    this.loading = true;
    this.http.get(url + 'ritel/issueactive?cdOnline=2&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.series = res.json();
        if (this.series.length > 0) {
          this.seriesId = this.series[0].SERIES_ID;
          for (var i = 0; i < this.series.length; i++) {
            if (this.seriesId == this.series[i].SERIES_ID) {
              this.paramSeries = this.series[i];
              break;
            }
          }
          this.getIssues(1);
          //this.getRawdata();
        } else if (this.series.length == 0) {
          //this.toastr.warning('Masa penawaran telah berakhir');
          this.loading = false;
        } else {
          this.loading = false;
        }
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getRawdata() {
    this.loading = true;
    this.http.get(url + 'ritel/rawdata?seriesId=' + this.seriesId + '&aucType=1&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.rawdata = res.json();
        this.excelService.exportAsExcelFile(this.rawdata, this.paramSeries.SERIES_NAME);
        //onsole.log(this.series);
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getIssues(pageNumber: number) {
    this.loading = true;
    this.all = true;
    //this.pagedList = {};
    this.issuances = [];
    this.http.get(url + 'ritel/bidsonline?seriesId=' + this.seriesId + '&search=' + this.search + '&ssId=' + this.ssId + '&statusId=' + this.status + '&pageNumber=' + pageNumber + '&pageSize=' + this.pageSize + '&sort=' + this.sort + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.pagedList = res.json();
        this.issuances = this.pagedList.Model.Records;
        this.pageNumber = pageNumber;
        this.child.getPagination(pageNumber, this.pagedList.Model);
        this.totBids = this.pagedList.Model.TotalNominal;
        for (let i = 0; i < this.issuances.length; i++) {
          var a = new Date(this.issuances[i].BidDate);
          var localOffset = a.getTimezoneOffset() * 60000;
          var localTime = a.getTime() + localOffset;
          this.issuances[i].BidDate = new Date(localTime);
        }

        // this.totBids = 0;
        // this.totAlts = 0;
        // for (var i = 0; i < this.issuances.length; i++) {
        //   this.totBids += this.issuances[i].BID_AMT;
        //   this.totAlts += this.issuances[i].ALT_AMT;
        // }
        /*if (!this.paramSeries.OPEN) {
          this.toastr.warning('Masa penawaran telah berakhir');
        }*/
        this.getCds(28);
        this.getSeriesSa();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getSeriesSa() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/seriessa?seriesId=' + this.seriesId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.seriessa = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getCds(cgNo: number) {
    this.loading = true;
    var result : any = [];
    this.cds = [];
    this.http.get(Globals.serviceUrl + 'ref/cds?cgno=' + cgNo + '&t' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        result = res.json();
        for (let i = 0; i < result.length; i++) {
          const element = result[i];
          if (element.CD_CODE >= "3") {
            this.cds.push(element);
          }
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  pageChange(pageNumber: number) {
    if (this.all) {
      this.getIssues(pageNumber);
    }
  }

  downloadCSV() {
    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '"}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'ExportCSVOnline?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

  CSVKSEI() {
    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '"}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'ExportCSVOnlineKSEI?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

  CSVDJPB() {
    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '"}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'ExportCSVOnlineDJPB?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

  ExportExcel() {
    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '"}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'ExporttoExcel?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

  scroll() {
    $('.pane-hScroll').scroll(function () {
      $('.pane-vScroll').width($('.pane-hScroll').width() + $('.pane-hScroll').scrollLeft());
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/ritel-online/custom-pemesanan/custom-pemesanan.component.ts